import { useEffect } from 'react';
import { NewSuitabilityData } from './types';

/**
 * Keeps the flow's data and step in sessionStorage so a reload resumes it. While `paused` nothing
 * is written: a flow opened from an approved Siesta proposal holds blank data until the pre-filler
 * has chosen the client and template, and saving that would make a reload resume a later step with
 * nothing chosen, and no pre-fill left to apply because the saved session takes priority.
 */
export function useFlowSessionPersistence(
  storageKey: string,
  data: NewSuitabilityData,
  stepIndex: number,
  paused: boolean,
) {
  useEffect(() => {
    if (paused) return;
    sessionStorage.setItem(storageKey, JSON.stringify(data));
  }, [data, storageKey, paused]);

  useEffect(() => {
    if (paused) return;
    sessionStorage.setItem(`${storageKey}-step`, String(stepIndex));
  }, [stepIndex, storageKey, paused]);
}
